import React from 'react'
import { I18n } from 'react-redux-i18n';
import WidgetUtils from "../utils/WidgetUtils";
import directValueWidgetIcon from "../../shared/img/direct-value-widget.svg";
import stickyNoteWidgetIcon from "../../shared/img/sticky-note.svg";
import controllerWidgetIcon from "../../shared/img/controller-widget.svg";
import iFrameWidgetIcon from "../../shared/img/iframe-widget.svg";
import chartWidgetIcon from "../../shared/img/chart-widget.svg";
import titleWidgetIcon from "../../shared/img/title-widget.svg";
import PropTypes from "prop-types";

const WidgetChoosePanel = ({
    widgetsCategory,
    getWidgetForm,
}) => {
    return <div className="row col-lg-12" >
        {
            widgetsCategory.widgets
                .map((widget, index) => {
                    return (
                        <div
                            style={{ width: "33%" }}
                            key={"widget-" + index}
                            className={"col-lg-4 col-md-6"}
                        >
                            {getWidgetExample(widget, getWidgetForm)}
                        </div>
                    );
                })
        }
    </div>;
};

function getWidgetExample(widgetInfo, getWidgetForm) {
    let widgetIcon = "";
    let widgetDisplayName = "";

    switch (widgetInfo) {
        case WidgetUtils.WidgetType.DIRECT_VALUE:
            widgetIcon = directValueWidgetIcon;
            widgetDisplayName = I18n.t("dashboard.widgets.types.DIRECT_VALUE");
            break;
        case WidgetUtils.WidgetType.STICKY_NOTE:
            widgetDisplayName = I18n.t("dashboard.widgets.types.STICKY_NOTE");
            widgetIcon = stickyNoteWidgetIcon;
            break;
        case WidgetUtils.WidgetType.CONTROLLER:
            widgetIcon = controllerWidgetIcon;
            widgetDisplayName = I18n.t("dashboard.widgets.types.CONTROLLER");
            break;
        case WidgetUtils.WidgetType.IFRAME:
            widgetDisplayName = I18n.t("dashboard.widgets.types.IFRAME");
            widgetIcon = iFrameWidgetIcon;
            break;
        case WidgetUtils.WidgetType.COMPLEX_CHART:
            widgetDisplayName = I18n.t("dashboard.widgets.types.COMPLEX_CHART");
            widgetIcon = chartWidgetIcon;
            break;
        case WidgetUtils.WidgetType.TITLE:
            widgetDisplayName = I18n.t("dashboard.widgets.types.TITLE");
            widgetIcon = titleWidgetIcon;
            break;
        default:
            throw new Error("Unknown widget type: " + widgetInfo);
    }

    return (
        <div className={"widget-example-highlight widgets-size"} onClick={() => getWidgetForm(widgetInfo)}>
            <div className={"ibox float-e-margins widget"}>
                <div className={"ibox-title widget-title-area widget-top-corners"} style={{ borderTop: "0px" }}>
                    <h5 className={'widget-title-description col-xs-6 col-lg-6 col-md-6 col-sm-6 col-xs-6'}>{widgetDisplayName}</h5>
                </div>
                <div
                    className={"ibox-content-widget widget-bottom-corners ibox-content-center-items ibox-content"}
                    style={{ overflow: "hidden" }}>
                    <img className={"widget-image-example"} src={widgetIcon} alt="Error Loading File" />
                </div>
            </div>
        </div>
    );
}

WidgetChoosePanel.propTypes = {
    widgetsCategory: PropTypes.object,
    getWidgetForm: PropTypes.func,
};

export default WidgetChoosePanel;